import React, { useState, useEffect, useContext, useRef } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import PinInput from "../components/PinInput";
import HomeButton from "../components/HomeButton";
import SaapApi from "../sdk/SaapApi";
import HttpService from "../sdk/HttpAxios";
import NavigationContext from "../components/NavigationContext";

const UnlockPage = () => {
  const [pin, setPin] = useState("");
  const [status, setStatus] = useState("Enter unlock code and press Unlock.");
  const [unlocking, setUnlocking] = useState(false);

  const [supportsBluetooth, setSupportsBluetooth] = useState(false);

  const [terminal, setTerminal] = useState("");
  const [sdkId, setSdkId] = useState(null);
  const [api, setApi] = useState(null);

  const { setDisableHome } = useContext(NavigationContext);
  const inputRef = useRef(null);

  /* ✅ Bluetooth + SDK init */
  useEffect(() => {
    setSupportsBluetooth(!!navigator.bluetooth);

    const pathname = window.location.pathname || "";
    const m = pathname.match(/\/code\/([^/]+)/i);
    const pinFromPath = m ? decodeURIComponent(m[1]) : null;
    const qs = new URLSearchParams(window.location.search);
    const pinFromQuery = qs.get("code");
    const pin = pinFromPath || pinFromQuery;
    if (pin) setPin(pin);

    console.log("PIN", pin);

    (async () => {
      try {
        const apiInstance = SaapApi.getInstance();
        const resp = await apiInstance.init("saap-esore-web");
        setSdkId(resp.sdkId);

        apiInstance.setListener({
          onNotification: (code, msg) => {
            console.log("NOTIFICATION:", code, msg);
            if (code == SaapApi.NOTIF_LOCK_UNLOCKED) {
              setStatus("Unlocked. You may open the door.");
              setTimeout(() => {
                window.location.href = "/";
              }, 20000);
            } else if (code.includes("ERROR") || code.includes("FAILED")) {
              setStatus("Something Wrong! Please Contact Support.");
              // setTimeout(() => {
              //   window.location.href = "/";
              // }, 3000);
            }
          },
        });

        setApi(apiInstance);
      } catch (err) {
        console.error(err);
        setStatus("Failed to initialize SDK");
      }
    })();
  }, []);

  /* ✅ Auto-scroll input into view when keyboard opens */
  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;

    const handler = () => {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 300);
    };

    el.addEventListener("focus", handler);
    return () => el.removeEventListener("focus", handler);
  }, []);

  const validate = () => {
    if (!pin || pin.length !== 6) {
      setStatus("Please enter a 6-digit PIN.");
      return false;
    }
    if (!supportsBluetooth) {
      setStatus("Bluetooth not supported on this device.");
      return false;
    }
    if (!api || !sdkId) {
      setStatus("Not ready.");
      return false;
    }
    return true;
  };

  const unlockWithPin = async () => {
    if (!validate()) return;

    // Request token for my order
    let order;
    const http = new HttpService();

    try {
      setStatus("Please wait while verifying your orders...");
      order = await http.requestToken(sdkId, pin);
    } catch (error) {
      if (error.status === 404) {
        setStatus(
          "We can't find any open order. Please check the PIN or contact suppor.",
        );
      }
      setUnlocking(false);
      return;
    }

    if (!order || !order.token) {
      setStatus(
        "We can't find any open order. Please check the PIN or contact suppor.",
      );
      return;
    }

    // Execute unlock command with the token
    console.log("Token", order.token);

    setStatus("Connecting...");
    setUnlocking(true);
    setDisableHome(true);

    try {
      console.log("Sending token...", order.token);
      await api.executeToken(order.token, SaapApi.LOCKER_ACTION_UNLOCK);
      console.log("Command Executed...");
    } catch (err) {
      console.log(`Unlock failed: ${err.message}`);
      setStatus(`Unlock failed. Pease retry.`);
      setUnlocking(false);
    } finally {
      setDisableHome(false);
    }
  };

  // ✅ If Bluetooth is not supported, render only the message
  if (!supportsBluetooth) {
    return (
      <MobilePageLayout>
        <img src="/locker.png" className="locker" alt="SAFECLOAK" />
        <div style={{ textAlign: "center" }}>
          <h2 className="page-title">SmartStore</h2>
          <p>
            Sorry! Unlocking is not supported from this device.
            <br />
            Please contact support
          </p>
        </div>
      </MobilePageLayout>
    );
  }

  return (
    <MobilePageLayout
      ctaLabel={unlocking ? "Unlock" : "Unlock"}
      onCtaClick={unlockWithPin}
      ctaDisabled={unlocking || pin.length !== 6}
    >
      <HomeButton />
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <h2 className="page-title">Unlock</h2>

      <PinInput
        defaultPin={pin}
        length={6}
        onChange={(val) => setPin(val)}
        onComplete={(val) => setPin(val)}
      />

      {status && <p className="status">{status}</p>}

      <ul className="instructions">
        <li>Make sure the Bluetooth on phone is turned on</li>
        <li>Press Unlock and Pair with the locker when prompted</li>
        <li>Close the door firmly after retrieving items</li>
      </ul>
    </MobilePageLayout>
  );
};

export default UnlockPage;
